import FormItemBigImageButtons from './FormItemBigImageButtons';

export default FormItemBigImageButtons;